import React, { FunctionComponent } from 'react';

import {
  default as MuiTablePagination,
  TablePaginationProps,
} from '@mui/material/TablePagination';

const TablePagination: FunctionComponent<
  TablePaginationProps<React.ElementType>
> = (props: TablePaginationProps<React.ElementType>) => {
  return <MuiTablePagination {...props}></MuiTablePagination>;
};

export default TablePagination;
